import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { mergeGroups } from '../../services/GroupsService';
import { Group, MergeGroupsRequest } from '../../types/Groups';

type Result = UseMutationResult<Group, Error, MergeGroupsRequest>;

function useMergeGroups(successCb: () => void, failureCb: (error: string) => void): Result {
  const queryClient = useQueryClient();

  return useMutation(mergeGroups, {
    onSuccess: () => {
      successCb();
      queryClient.invalidateQueries({ queryKey: ['groups'] });
    },
    onError: (error: Error) => {
      failureCb(error.message);
    },
  });
}

export default useMergeGroups;
